<p-sidebar *ngIf="sidebarVisible && isResponse && selectedQuestion" [(visible)]="sidebarVisible"
    (onHide)="onHideSidebar()" (visibleChange)="onHideSidebar()" position="right" [showCloseIcon]="false" [blockScroll]="true">
    <div class="w-full flex pt-4" *ngIf="!changeScoreSidebarVisible">
        <div class="w-6 flex">
            <p-button class="back-button" icon="pi pi-arrow-left" (click)="goToPreviousQuestion()"></p-button>
            <p-button class="next-button" icon="pi pi-arrow-right" (click)="goToNextQuestion()"></p-button>
        </div>
    </div>

    <app-question-detail *ngIf="!changeScoreSidebarVisible" [question]="selectedQuestion"></app-question-detail>

    <app-simple-vinter-answer-base-component *ngIf="!changeScoreSidebarVisible" [question]="selectedQuestion"
        [codingAnswer]="codingAnswer" [multipleChoiceAnswer]="multipleChoiceAnswer" [openEndedAnswer]="openEndedAnswer"
        [videoAnswer]="videoAnswer" [speakingAnswer]="speakingAnswer"
        [pronunciationVideoAnswer]="pronunciationVideoAnswer" [writingAnswer]="writingAnswer"
        [questionCollectionCategoryId]="questionCollectionCategoryId">
    </app-simple-vinter-answer-base-component>

    <div class="ml-5" *ngIf="isShowScoreChangeComponent && isQuestionAnswerChangeComponentVisible">     
        <app-simple-vinter-change-vinter-score *ngIf="sidebarComponentVisible" [key]="sidebarComponentKey"
            [answerContentID]="answerContentID" [vinterScore]="vinterScore" [applicantID]="applicantID" 
            [questionScoreDecPart]="questionScoreDecPart" [questionScoreIntPart]="questionScoreIntPart" (scoreChanged)="onScoreChanged($event)">
        </app-simple-vinter-change-vinter-score>
    </div>
</p-sidebar>